export const messages = {
  title: {
    id: 'admin/promotions.form.duplicate.modal.title',
  },
  subtitle: {
    id: 'admin/promotions.form.duplicate.modal.subtitle',
  },
  general: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.general',
    },
    name: {
      id: 'admin/promotions.form.duplicate.modal.general.name',
    },
    dates: {
      id: 'admin/promotions.form.duplicate.modal.general.dates',
    },
  },
  commercialPolicies: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.commercial-policies',
    },
  },
  sellers: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.sellers',
    },
  },
  itemsAndBenefits: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.items-and-benefits',
    },
  },
  conditions: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.conditions',
    },
  },
  restrictions: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.restrictions',
    },
  },
  accumulation: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.accumulation',
    },
  },
  storefront: {
    label: {
      id: 'admin/promotions.form.duplicate.modal.storefront',
    },
  },
  buttons: {
    cancel: {
      id: 'admin/promotions.utils.cancel',
    },
    duplicate: {
      id: 'admin/promotions.form.duplicate.modal.duplicate',
    },
  },
}
